import { setApisURLs, DISABLED_ASSISTANT_ERROR } from "./api";
import { getUserInfo, getAuthHeadersData, triggerLogout } from "./api/auth-bridge";
import { getSelectedTenantApiKey, getCurrentTenant } from "./roles";
import i18n from "../i18n/i18n";

const isEmbedMode = new URLSearchParams(window.location.search).get("embed") === "true";
let isLoggingOut = false;

const isApiKeyError = (message = "") => (
  message.includes("Missing X-API-Key header") || message.includes("Invalid API key")
);

const triggerLogoutOnce = () => {
  if (isEmbedMode || isLoggingOut) {
    return;
  }

  isLoggingOut = true;
  setTimeout(() => {
    triggerLogout();
    isLoggingOut = false;
  }, 100);
};

export const fetch_stream = async (
  endpoint,
  body,
  onChunk,
  endFunc = () => {},
  onError = (error) => console.error("Stream error:", error),
  isJson = true,
  attachment = null
) => {
  try {
    const tenantApiKeyMap = await getUserInfo();
    const authHeadersData = await getAuthHeadersData();
    const apiKey = getSelectedTenantApiKey(tenantApiKeyMap) || authHeadersData.apiKey || process.env.REACT_APP_API_KEY;
    const tenant = getCurrentTenant();

    setApisURLs(tenant);

    const baseURL =
      tenant && typeof tenant === "string" && tenant.toLowerCase().endsWith("prod")
        ? process.env.REACT_APP_API_URL_PROD
        : process.env.REACT_APP_API_URL;

    let headers = {};

    //  Now, always use FormData to send messages
    const formData = new FormData();

    Object.keys(body).forEach(key => {
      if (body[key] != null) {
        formData.append(key, body[key]);
      }
    });

    // If there is an separated attachment, add it to the FormData
    if (attachment != null) {
      formData.append("file_1", attachment);
    }

    if (apiKey) {
      headers["X-Api-Key"] = apiKey;
    }

    // Add Bearer token if available
    const { accessToken } = authHeadersData;
    if (accessToken) {
      headers["Authorization"] = `Bearer ${accessToken}`;
    }

    const response = await fetch(baseURL + endpoint, {
      method: "POST",
      headers: headers,
      body: formData,
    });

    // Check for HTTP errors
    if (!response.ok) {
      const errorText = await response.text();
      try {
        const errorJson = JSON.parse(errorText);
        const message = errorJson.error || errorText;
        if (errorJson.error && errorJson.error.includes("ChatStatus is RUNNING")) {
          onError({ type: "chatRunning", message: errorJson.error });
          return;
        }
        if (response.status === 401 && !isApiKeyError(message)) {
          triggerLogoutOnce();
        }
        onError({
          type: "httpError",
          message,
          status: response.status,
          // Same message the axios interceptor sets, so both paths end up in the same modal.
          ...(message === DISABLED_ASSISTANT_ERROR && { customMessage: i18n.t("assistantDisabled") }),
        });
      } catch {
        if (response.status === 401 && !isApiKeyError(errorText)) {
          triggerLogoutOnce();
        }
        onError({ type: "httpError", message: errorText, status: response.status });
      }
      return;
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    const stream = new ReadableStream({
      start(controller) {
        function procesarDatos() {
          reader.read().then(({ done, value }) => {
            if (done) {
              const tail = decoder.decode();
              if (tail) onChunk(tail);
              controller.close();
              return;
            }
            const mensaje = decoder.decode(value, { stream: true });
            if (mensaje) onChunk(mensaje);
            controller.enqueue(value);
            procesarDatos();
          });
        }
        procesarDatos();
      },
    });

    const finalResponse = new Response(stream);
    await finalResponse.text();
    endFunc();
  } catch (error) {
    onError(error);
  }
};

